import { el } from 'date-fns/locale';

const urls = {
  fetchOperatorVehicleList() {
    return `/supply/vehicle/app/get-vehicles`;
  },
  fetchOperatorVehicleListV2() {
    return `/rest/tesseract/v1/operator/vehicles`;
  },
  vehicleUpdateV2() {
    return `/rest/tesseract/v1/operator/vehicles`;
  },
  postUploadDocUrl(payload: any) {
    return `/supply/vehicle/app/upload-url`;
  },

  vehicleUpdate(payload: any) {
    return `/supply/vehicle/app/update-vehicle`;
  },

  getUploadedDocImg(payload: any, typeImg: any) {
    return `/supply/vehicle/app/view-url/${typeImg}/${payload}`;
  },

  getOperatorDocListx(payload: any) {
    return `/supply/operator/app/get-operator-documents`;
  },

  operatorUpdateDoc(payload: any) {
    return `/supply/operator/app/update-operator-documents`;
  },
  fetchGPSImageUrls() {
    return `acquisition/gps/ImageUrls`;
  },
  gpsorderRequest() {
    return `/acquisition/gps/orderRequest`;
  },
  fetchGpsVariant() {
    return `/rest/argus/app/services/gps/info`;
    //return `/rest/argus/gps/buy-gps-variants`;
  },
  fetchOperatorVehicleTyreSizeTonHeight(payload: any) {
    const url = `/supply/vehicle/app/`;

    const bodyType = payload.bodyType ? `tyre-count?&bodyType=${payload.bodyType}` : '';
    const tyreCount = payload.tyreCount ? `size?&bodyType=${payload.bodyType}&tyreCount=${payload.tyreCount}` : '';
    const tonnage = payload.sizeInFeet
      ? `tonnage?&bodyType=${payload.bodyType}&tyreCount=${payload.tyreCount}&sizeInFeet=${payload.sizeInFeet}`
      : '';
    const height = payload.sizeInFeet
      ? `height?&bodyType=${payload.bodyType}&tyreCount=${payload.tyreCount}&sizeInFeet=${payload.sizeInFeet}&tonnage=${payload.tonnage}`
      : '';

    var main = payload.tyreCount ? tyreCount : payload.sizeInFeet ? tonnage : bodyType;
    const main2 = () => {
      if (payload.tonnage) {
        return height;
      }
      if (payload.sizeInFeet) {
        return tonnage;
      } else if (payload.tyreCount) {
        return tyreCount;
      } else {
        return bodyType;
      }
    };

    return url + main2();
  },
  uploadDocument() {
    return `rest/tesseract/v1/profile/document/upload-url`;
  },

  fetchRequiredVehicleData(vId: string | number) {
    return `rest/tesseract/v1/vehicle/list/${vId}`;
  },
};

export default urls;
